import Tree from './Tree';
export default Tree;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/tree/index.js
// module id = 860
// module chunks = 3